/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchCMARecurringCostItemDto
 */
export interface PatchCMARecurringCostItemDto {
    /**
     * 
     * @type {string}
     * @memberof PatchCMARecurringCostItemDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof PatchCMARecurringCostItemDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchCMARecurringCostItemDto
     */
    frequency: string;
    /**
     * 
     * @type {string}
     * @memberof PatchCMARecurringCostItemDto
     */
    type: string;
}

/**
 * Check if a given object implements the PatchCMARecurringCostItemDto interface.
 */
export function instanceOfPatchCMARecurringCostItemDto(value: object): value is PatchCMARecurringCostItemDto {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PatchCMARecurringCostItemDtoFromJSON(json: any): PatchCMARecurringCostItemDto {
    return PatchCMARecurringCostItemDtoFromJSONTyped(json, false);
}

export function PatchCMARecurringCostItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchCMARecurringCostItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'] == null ? undefined : json['value'],
        'frequency': json['frequency'],
        'type': json['type'],
    };
}

export function PatchCMARecurringCostItemDtoToJSON(json: any): PatchCMARecurringCostItemDto {
    return PatchCMARecurringCostItemDtoToJSONTyped(json, false);
}

export function PatchCMARecurringCostItemDtoToJSONTyped(value?: PatchCMARecurringCostItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
        'frequency': value['frequency'],
        'type': value['type'],
    };
}

